import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import NotificationSettings from './NotificationSettings';
import NotificationList from '../notifications/NotificationList';

const Notifications = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'settings';

  const tabs = [
    { id: 'settings', label: 'Notification Settings' },
    { id: 'notifications', label: 'Notifications' }
  ];

  const handleTabChange = (tabId) => {
    setSearchParams({ tab: tabId });
  };

  return (
    <div className="max-w-[1200px] mx-auto space-y-6 pb-8">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Notifications</h1>
        <p className="text-sm text-gray-500">Manage your notification preferences and view your notifications</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${
                  activeTab === tab.id
                    ? 'border-emerald-400 text-emerald-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === 'settings' && <NotificationSettings />}
        {activeTab === 'notifications' && <NotificationList />}
      </div>
    </div>
  );
};

export default Notifications;


